import type { AttributionEvent } from '@camelot/webview-utils'
import { checkIsWebView, recordAttributionEvent } from '@camelot/webview-utils'
import * as Sentry from '@sentry/vue'
import { useExtrasStore } from '~/stores/extras'
import { useOfferStore } from '~/stores/offer'

export function emitAppsflyerEvent(eventName: string, eventParams?: Record<string, string | number>): void {
  try {
    if (typeof window === 'undefined' || !checkIsWebView(window))
      return

    const event: AttributionEvent = { eventName }
    if (eventParams)
      event.eventParams = eventParams

    recordAttributionEvent(window, event)
  }
  catch (e) {
    Sentry.captureException(e)
  }
}

export function trackAppsflyerPrebookingSuccess(): void {
  const value = (useOfferStore().selectedOffer?.price ?? 0) + useExtrasStore().totalExtraPrice
  emitAppsflyerEvent('prebooking_success', { value })
}
